/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
    FETCH_LOTTERY_STATISTICS_LOADING,
    FETCH_LOTTERY_STATISTICS_SUCCESS,
    FETCH_LOTTERY_STATISTICS_ERROR,
} from '../constants';

export default function fetchLotteryStatistics(year: string) {
    return (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
        dispatch({
            type: FETCH_LOTTERY_STATISTICS_LOADING,
            payload: true,
        });

        return axios
            .get(`${process.env.API}/lottery/statistics?year=${year}`)
            .then((response) => {
                dispatch({
                    type: FETCH_LOTTERY_STATISTICS_SUCCESS,
                    payload: response.data.lottery_metrics,
                });

                dispatch({
                    type: FETCH_LOTTERY_STATISTICS_LOADING,
                    payload: false,
                });

                Promise.resolve(response);
            })
            .catch((error) => {
                dispatch({ type: FETCH_LOTTERY_STATISTICS_ERROR, error });

                dispatch({
                    type: FETCH_LOTTERY_STATISTICS_LOADING,
                    payload: false,
                });
            });
    };
}
